import React from "react";
import {
  Col,
  Row,
  Input,
  Label,
  FormFeedback,
  Button,
} from "reactstrap";


const chargeTypeOptions = [
  { value: "P", label: "P" },
  { value: "F", label: "F" },
];


interface DeliveryChargeFormProps {
  validation: any;
  isEdit?: boolean;
  categories?: any[];
  charges?: any[];
}

const DeliveryChargeForm: React.FC<DeliveryChargeFormProps> = ({
  validation,
  isEdit = false,
  categories,
  charges,
}) => {
  return (
    <form onSubmit={validation.handleSubmit}>
      <div className="px-3 py-2">
        <h5>{isEdit ? "Edit Charge" : "New Charge"}</h5>
        <Row className="g-3 mt-2">
        <Col md={12}>
            <Label>Time Slot <span className="text-danger">*</span></Label>
            <Input
                type="select"
                name="slotid"
                value={validation.values.slotid}
                onChange={validation.handleChange}
                invalid={!!(validation.touched.slotid && validation.errors.slotid)}
            >
                <option value="">Select time slot</option>
                <option value={1}>Door-step Delivery (Within 4 hrs)</option>
                <option value={2}>Door-step Delivery (Same Day)</option>
                <option value={3}>Door-step Delivery (Next Day)</option>
                <option value={4}>Door-step Delivery (Within 2 Days)</option>
            </Input>
        <FormFeedback>{validation.errors.slotid}</FormFeedback>
        </Col>
        </Row>
         <Row className="g-3 mt-2">
          <Col md={6}>
            <Label>Minimum Amount</Label>
            <Input
              name="min_amount"
              value={validation.values.min_amount}
              onChange={validation.handleChange}
              invalid={!!(validation.touched.min_amount && validation.errors.min_amount)}
              placeholder="Type here..."
            />
            <FormFeedback>{validation.errors.min_amount}</FormFeedback>
          </Col>
          <Col md={6}>
            <Label>Maximum Amount</Label>
            <Input
              name="max_amount"
              value={validation.values.max_amount}
              onChange={validation.handleChange}
              invalid={!!(validation.touched.max_amount && validation.errors.max_amount)}
              placeholder="Type here..."
            />
            <FormFeedback>{validation.errors.max_amount}</FormFeedback>
          </Col>
        </Row>
        <Row className="g-3 mt-2">
          <Col md={12}>
            <Label>Charge type <span className="text-danger">*</span></Label>
            <Input
              type="select"
              name="chage_type"
              value={validation.values.chage_type}
              onChange={validation.handleChange}
              invalid={
                !!(validation.touched.chage_type && validation.errors.chage_type)
              }
              >
              <option value="" disabled hidden>Select </option>
              {chargeTypeOptions.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </Input>
            <FormFeedback>{validation.errors.chage_type}</FormFeedback>
          </Col>
          <Col md={12}>
            <Label>Value <span className="text-danger">*</span></Label>
            <Input
              name="charge_value"
              value={validation.values.charge_value}
              onChange={validation.handleChange}
              invalid={
                !!(validation.touched.charge_value && validation.errors.charge_value)
              }
              placeholder="Type here..."
            />
            <FormFeedback>{validation.errors.charge_value}</FormFeedback>
          </Col>
        </Row>
        <div className="d-flex justify-content-end mt-4">
          <Button color="primary" type="submit">
            {isEdit ? "Update" : "Done"}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default DeliveryChargeForm;
